import React from 'react';
import ReactDatePicker from 'react-datepicker';

import styled from '@emotion/styled';

import 'react-datepicker/dist/react-datepicker.css';

interface WrapperProps {
  fullWidth?: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  box-sizing: border-box;
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  padding: 6px 10px;

  .react-datepicker-wrapper {
    display: block;
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    box-sizing: border-box;
  }
`;

interface DatePickerProps {
  selected?: Date | null;
  onChange: (date: Date | null) => void;
  fullWidth?: boolean;
  [key: string]: any;
}

const DatePicker: React.FC<DatePickerProps> = ({
  selected = null,
  onChange,
  fullWidth = false,
  ...props
}) => (
  <Wrapper fullWidth={fullWidth}>
    <ReactDatePicker
      {...props}
      selected={selected}
      onChange={onChange}
      className="react-datepicker__input-text"
    />
  </Wrapper>
);

export default DatePicker;
